export const environment = {
  production: false,
  backendUrl: 'https://backend.dev-dms.dreamix.eu',
  firebase: {
    apiKey: 'AIzaSyDffhIhHJYURynad1sj1h4vdPiki0PGgNk',
    authDomain: 'dreamix-management-system.firebaseapp.com',
    databaseURL: 'https://dreamix-management-system.firebaseio.com',
    projectId: 'dreamix-management-system',
    storageBucket: 'dreamix-management-system.appspot.com',
    messagingSenderId: '1026810753126',
    appId: '1:1026810753126:web:54de00ba6b09a126807da7',
    measurementId: 'G-9LW3PNDB2T',
  },
  google: {
    calendarApiKey: 'AIzaSyAJW-O7SoGLWoxh8Ka4btsL9FX9ejVrzZw',
    clientId: '103728556371-qn51efoh5t17g6b5tsp4l18o5cjfh5it.apps.googleusercontent.com',
    hostName: 'dev-dms.dreamix.eu',
  },
};
